export default __webpack_public_path__ + "static/SectionTwo_02_04-766ba01215c32c4f277a8e4303eec4c1.webp";